import axiosClient from "../../network";

export default class notificationService {
  static getNotifications({ pageNumber = 1, limit = 10, parentId } = {}) {
    const params = { pageNumber, limit };
    if (parentId !== undefined && parentId !== null) {
      params.parentId = parentId;
    }
    return axiosClient
      .get("user/getUnseenNotfication", {
        params,
        headers: { "ngrok-skip-browser-warning": "true" }
      })
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        if (error.data) {
          return { error: error.data };
        }
        return {
          error
        };
      });
  }

  static readNotification(payload) {
    return axiosClient
      .post("user/seenNotification", payload, {
        headers: { "ngrok-skip-browser-warning": "true" }
      })
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        if (error.data) {
          return { error: error.data };
        }
        return {
          error
        };
      });
  }
}
